import { render, staticRenderFns } from "./MealVersions.vue?vue&type=template&id=2d012ca6&"
import script from "./MealVersions.vue?vue&type=script&lang=js&"
export * from "./MealVersions.vue?vue&type=script&lang=js&"
import style0 from "./MealVersions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports